import React, { Fragment, useState } from "react";
import styles from "./fba-listings-list.module.css";
import Pill from "@/components/Pill/Pill";
import { FbaListing, useFbaListingContext } from "@/contexts/FbaListingContext";
import FbaListingsListItem from "../FbaListingsListItem";
import FbaEditListingDrawer from "../FbaEditListingDrawer";
import Flex from "@/components/Flex/Flex";

type FbaListingsListProps = {};

const FbaListingsList = ({}: FbaListingsListProps) => {
  const { fbaListings } = useFbaListingContext();
  const [editingListing, setEditingListing] = useState<FbaListing>(null);

  const skus = new Set<string>();
  fbaListings.map((listing) => skus.add(listing.sku));

  const handleEditListing = (listing: FbaListing) => {
    setEditingListing(listing);
  };

  return (
    <Flex className={styles.styledForm} direction="column">
      {!!editingListing && (
        <FbaEditListingDrawer
          listing={editingListing}
          onClose={() => setEditingListing(null)}
        />
      )}

      <Flex direction="column" className={styles.productsWithinListingHeader}>
        <Flex>
          <span className={`strong`} style={{ marginRight: "0.5rem" }}>
            FBA Listings
          </span>
          <Pill>
            <span>{fbaListings.length}</span>
          </Pill>
        </Flex>
      </Flex>

      {fbaListings.length === 0 && (
        <Flex
          direction="column"
          className={styles.emptyBox}
        >
          <img src="/images/box-add.svg" height="100" />
          <span className={"strong"}>No listings yet.</span>
          <p className={styles.emptySubText}>Choose products from the list on the left to create a listing.</p>
        </Flex>
      )}

      <div className={styles.listingItemsContainer}>
        {fbaListings.map((listing) => {
          return (
            <Fragment key={listing.sku}>
              <FbaListingsListItem
                listing={listing}
                onEditItemClicked={handleEditListing}
              />
            </Fragment>
          );
        })}
      </div>

      {fbaListings.length > 0 && (
        <div className={styles.stateBox}>
          <Flex justify="space-between" align="center">
            <span>Total SKUs</span>
            <span className="strong">{skus.size}</span>
          </Flex>
        </div>
      )}
    </Flex>
  );
};

export default FbaListingsList;